export default "__VITE_ASSET__DX1qL7QK__"